import "./BackButton.scss";

import { ReactComponent as BackIcon } from '../../assets/images/back-icon.svg';
import { useNavigate } from "react-router-dom";


const BackButton = ({ showLeftIcon, text, navigateTo, actionButtons, onClick }) => {

    const navigate = useNavigate();

    const handleOnClick = (event) => {
        if (typeof onClick === 'function') {
            try {
                const shouldContinue = onClick(event);
                if (shouldContinue === false) {
                    return;
                }
            } catch (error) {
                console.error('BackButton: Error during onClick:', error);
            }
        }

        if (navigateTo) {
            navigate(navigateTo);
        }
    };

    return (
        <div className='breadcrumb-button mt-4'>
            <div className="breadcrumb-content">
                {showLeftIcon && (
                    <div className="image-wrapper" onClick={handleOnClick}>
                        <BackIcon />
                    </div>
                )}
                <div className="text">{text}</div>
            </div>
            {actionButtons && (
                <div className="action-buttons">
                    {actionButtons}
                </div>
            )}
        </div>
    )
}

export default BackButton;